import { useState } from "react";
import axios from 'axios';

export const SignInForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const currentUrl = window.location.href;

    try {
      const response = await axios.post('/login', {
        email,
        password,
        remember: rememberMe,
      }, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.data) {
        window.location.href = currentUrl;
        return;
      } else {
        setError('Login succeeded, but redirect failed. Please Refresh your browser.');
        setLoading(false);
      }

    } catch (err) {
      let errorMessage = 'Login failed. Please check your credentials.';

      if (err.response && err.response.data && err.response.data.errors) {
        const errors = err.response.data.errors;
        const firstErrorKey = Object.keys(errors)[0];
        if (firstErrorKey && errors[firstErrorKey].length > 0) {
          errorMessage = errors[firstErrorKey][0];
        }
      } else if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }

      setError(errorMessage);
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="modal-content">
      <div className="modal-body p-4">
        <h1 className="mb-4 font-weight-bold">Sign In</h1>
        
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <fieldset className="email-input-fieldset">
              <legend>Email</legend>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder=" "
              />
            </fieldset>
          </div>

          <div className="form-group mb-3">
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control form-control-lg"
                placeholder="Password"
                id="passwordInput"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="position-absolute"
                onClick={togglePasswordVisibility}
                style={{
                  border: 'none',
                  background: 'transparent',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#000',
                  padding: '0.375rem 0.75rem'
                }}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="form-group mb-4">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="rememberMe"
                name="remember"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label className="form-check-label m-0" htmlFor="rememberMe">
                Remember Me
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-lg btn-danger w-100 mb-3"
            style={{
              backgroundColor: '#FA4616 ',
              borderRadius: 0,
              color: '#fff'
            }}
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'SIGN IN'}
          </button>
        </form>

        <div className="mt-3">
          <p className="mb-2 text-black">
            Forgot Password? Reset <a href="/password/reset" className="text-decoration-underline font-weight-bold">HERE</a>
          </p>
          <p className="mb-2 text-black">
            Are you a client but don't have a web login? <a href="/register-client" className="text-decoration-underline font-weight-bold">SIGN UP</a>
          </p>
          <p className="mb-0 text-black">
            Don't have an existing trade account with us? <a href="/account-registration" className="text-decoration-underline font-weight-bold">REGISTER NOW</a>
          </p>
        </div>
      </div>
    </div>
  );
};